import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    estadoCivil: [],
  },
  getters: {
    getEstadoCivil: (state) => state.estadoCivil,
  },
  mutations: {
    SET_ESTADO_CIVIL(state, estadoCivil) {
      state.estadoCivil = estadoCivil;
    },
  },
  actions: {
    async fetchEstadoCivil({ commit }) {
      await axios
        .get('/PoliciaCuadrantes/EstadoFuerza/estadoCivil')
        .then((response) => {
          commit('SET_ESTADO_CIVIL', response.data.data);
        });
    },
  },
};
